import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Cuál es la diferencia entre TMS acelerada y convencional?",
    answer:
      "La TMS convencional suele administrar una sesión diaria durante seis a nueve semanas (unas 30–36 sesiones). La TMS acelerada, como SAINT®, administra 50 sesiones en cinco días con orientación por fMRI y patrón theta burst. Ambas están autorizadas por la FDA para la depresión, pero son protocolos distintos.",
  },
];

export const esAcceleratedVsConventional = makeEsArticle({
  slug: "accelerated-tms-vs-conventional-tms",
  title: "TMS acelerada frente a TMS convencional: diferencias",
  description:
    "Comparación de TMS acelerada (SAINT®) y TMS convencional: duración del tratamiento, número de sesiones, método de orientación y para quién está indicada cada una.",
  h1: "TMS acelerada frente a TMS convencional",
  breadcrumbLabel: "TMS acelerada vs convencional",
  shortAnswer:
    "La TMS convencional se administra como una sesión diaria, cinco días por semana, durante unas seis semanas (aproximadamente 30–36 sesiones). SAINT® es una TMS acelerada que administra 50 sesiones en cinco días consecutivos con orientación individualizada por fMRI y patrón theta burst. Ambas están autorizadas por la FDA para el trastorno depresivo mayor; la diferencia principal es el calendario y el método de orientación.",
  keyTakeaways: [
    "La TMS convencional dura unas seis semanas con una sesión diaria.",
    "SAINT® comprime 50 sesiones en cinco días.",
    "SAINT® usa orientación individualizada por fMRI; la TMS convencional usa mediciones del cuero cabelludo.",
    "SAINT® usa patrón theta burst; la TMS convencional usa estimulación repetitiva estándar.",
    "Ambas están autorizadas por la FDA para el trastorno depresivo mayor.",
  ],
  sections: [
    {
      heading: "Duración y número de sesiones",
      paragraphs: [
        "La TMS convencional suele administrar 30 a 36 sesiones, una por día, cinco días por semana, durante aproximadamente seis a nueve semanas. SAINT® administra 50 sesiones en cinco días consecutivos, con aproximadamente 10 sesiones por día y descansos de unos 50 minutos entre sesiones.",
      ],
    },
    {
      heading: "Método de orientación",
      paragraphs: [
        "La TMS convencional ubica la posición de la bobina con mediciones del cuero cabelludo. SAINT® utiliza una resonancia magnética funcional (fMRI) para localizar de forma individualizada el circuito cerebral asociado con la depresión en cada paciente y neuronavegación para colocar la bobina en el objetivo exacto en cada sesión.",
      ],
    },
    {
      heading: "Para quién está indicada cada una",
      paragraphs: [
        "Ambas están autorizadas por la FDA para el trastorno depresivo mayor en adultos. SAINT® está indicada para adultos que no han mejorado con antidepresivos. La elegibilidad para cualquiera de las dos se confirma mediante una evaluación psiquiátrica.",
        "La TMS convencional suele estar cubierta por los seguros. SAINT® suele ser de pago directo; el pago directo puede oscilar entre $25,000 y $28,000. Verificamos los beneficios de cada paciente sin costo, sea cual sea su aseguradora. La cobertura varía según el plan.",
      ],
    },
  ],
  faqs,
  sources: [
    {
      citation:
        "Cole EJ, et al. Stanford Neuromodulation Therapy (SNT): A Double-Blind Randomized Controlled Trial. Am J Psychiatry. 2022;179(2):132-141.",
      url: "https://doi.org/10.1176/appi.ajp.2021.20101429",
    },
  ],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
